import React from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Typography} from "../../../../designSystem/components/Typography";

const URL = 'https://console.cloud.google.com/storage/browser/ptshb-firestore-backup'

export const DatabaseManagementFeature = () => {
  const onClickGoToConsoleButton = () => {
    window.open(URL, '_blank');
  };

  return (
    <div className="w-full m-auto text-center">
      <Typography variant="captionMuted" className="mb-4">
        系統每日 00:00 自動備份，備份檔保留 186 天。
      </Typography>
      <ActionButton
        label="前往資料庫後台"
        onClick={onClickGoToConsoleButton}
      />
    </div>
  )
}
